"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SortOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M22.83 4a1 1 0 00-2 0v21.41L15.73 20a1 1 0 00-1.41-.06 1 1 0 00-.05 1.42l6.85 7.32a1 1 0 001.47 0L29.73 21a1 1 0 00-1.46-1.36l-5.44 5.83z"/><path d="M9.17 28a1 1 0 002 0V6.59l5.1 5.41a1 1 0 001.41.06 1 1 0 00.05-1.42l-6.85-7.32a1 1 0 00-1.47 0L2.27 11a1 1 0 101.46 1.36l5.44-5.83z"/>';
var SortOutlineSVG = function SortOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.SortOutlineSVG = SortOutlineSVG;
SortOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SortOutlineSVG);
exports.default = _default;